<template lang="html">
  <div>
    <div v-for="item in items" :key="item.id">
      <div v-html="parse(item).html_code"></div>
    </div>
  </div>
</template>

<script>
import parseComponent from '@/mixins/parseComponent'

export default {
  name: 'HTMLPreviewer',

  mixins: [parseComponent],

  props: {
    currentListItem: {
      type: Object,
      description: 'This is the type of list'
    },

    items: {
      type: Array,
      description: 'The current list item'
    }
  }
}
</script>

<style lang="sass">
</style>
